import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import DraftRenderer from '../../../components/DraftRenderer/DraftRenderer';

class PropertyDescription extends React.Component {
  render() {
    const hotel = this.props.hotel;
    return (
      <div className="row">
        <div className="col-md-12 hotel-details-description">
          <h4 className="hotel-highlight">
            Property Description &nbsp;<Button onClick={this.props.handleEdit}>Edit</Button>
          </h4>
          <DraftRenderer raw={hotel.description} placeholder="No property description." />
        </div>
      </div>
    );
  }
}
PropertyDescription.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};
export default PropertyDescription;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDescriptionView.js